
import modal from '@/components/common/modalManage'
import { CommonResponse, Subscription } from '@/components/common/model'
import VueSelect from '@/components/common/VueSelect.vue'
import { Company } from '@/components/master/features/Company/Company.model'
import agent, {
    coreServiceBaseURL,
    fortnoxServiceBaseURL,
    masterServiceBaseURL,
} from '@/services/agent'
import authService from '@/services/authService'
import preLoader from '@/services/preLoader'
import { useUserStore } from '@/store/useUserStore'
import { L10n, setCulture } from '@syncfusion/ej2-base'
import {
    CommandColumn,
    ColumnDirective as EColumn,
    ColumnsDirective as EColumns,
    GridComponent as EjsGrid,
    Group,
    Page,
    Resize,
    Search,
    Sort,
    Toolbar,
} from '@syncfusion/ej2-vue-grids'
import axios, { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { Module } from '../Module/Module.model'
import EndpointProvider from './EndpointProvider'
import {
    AzureJobStatusDetails,
    ModalType,
    NetvisorMasterSyncLogGetResponse,
    NetvisorDetailsSyncLogGetResponse,
    Property,
    PropertySyncLogDetails,
    RunStatus,
    SyncLog,
    SyncLogDetails,
    SyncLogDetailsGetResponse,
    SyncLogGetResponse,
    FinanceMasterSyncLogGetResponse,
    FinanceDetailsSyncLogGetResponse,
} from './SyncLog.model'
import ModuleEnum from '../../common/ModuleEnum'
import { ResponseBase } from '@/components/businesscentral/common/Common.model'
import toasterService from '@/services/toasterService'
import { DateRangePickerComponent as EjsDaterangepicker } from "@syncfusion/ej2-vue-calendars";
import moment from 'moment'
import { SHARED } from "../../common/Constants";
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns'
import { CheckBoxComponent } from '@syncfusion/ej2-vue-buttons'
import CardTitleComponent from '@/components/common/CardTitleComponent.vue'
import SearchComponent from '@/components/shared/SearchComponent.vue'
import "@/style.css"
import "@/components/master/features/SyncLog/SyncLogComponent.css"

let runStatus = RunStatus
let _syncLogData: Property = {} as Property
let _syncLogDetailsData: PropertySyncLogDetails = {} as PropertySyncLogDetails
let _syncLogForm: SyncLog = {} as SyncLog
let _moduleList: Module[] = []
let _subscriptionList: Subscription[] = []
const _endpointSelector = new EndpointProvider()
//let _companyList: Company[] = [];

export default defineComponent({
    setup() {
        const userStore = useUserStore()
        return { userStore }
    },
    components: {
        'ejs-grid': EjsGrid,
        'e-columns': EColumns,
        'e-column': EColumn,
        "ejs-dropdownlist": DropDownListComponent,
        'ejs-daterangepicker': EjsDaterangepicker,
        "ejs-checkbox": CheckBoxComponent,
        VueSelect,
        CardTitleComponent,
        SearchComponent,
    },
    provide: {
        grid: [Toolbar, Resize, Search, CommandColumn, Page, Sort, Group],
    },
    created() {
        this.gridLocalize()
    },
    data() {
        return {
            subscriptionList: _subscriptionList,
            subscriptionListFields: { value: "id", text: "organizationName" },
            moduleList: _moduleList,
            data: _syncLogData,
            form: _syncLogForm,
            moduleId: 0,
            isUpdate: false,
            isTableLoad: false,
            confirmTitle: '',
            confirmIsDelete: false,
            selectedState: null,
            companyId: 0,
            includePending: false,
            companies: [] as Company[],
            subscriptionId: '',
            details: {
                syncLogMasterId: 0,
                logPartitionKey: '',
                logRowKey: '',
                companyId: 0,
                rowSubscriptionId: '',
                data: _syncLogDetailsData,
                searchOptions: {
                    fields: [
                        //'Id',
                        //'LogId',
                        // "Entity",
                        'StartedAt',
                        'CompletedAt',
                        //'RunStatusId',
                        'HasError',
                        'ErrorMessage',
                        //'RowSynced',
                    ],
                    operator: 'contains',
                    ignoreCase: true,
                },
                toolbar: ['Search'],
                pageSettings: {
                    pageSizes: [10, 20, 50, 100],
                    pageSize: 50,
                    pageCount: 5,
                    state: { skip: 0, take: 50 } as any,
                },
            },
            jobRunStatus: {} as AzureJobStatusDetails,

            searchOptions: {
                fields: [
                    'Id',
                    //   "CompanyId",
                    'RequestedAt',
                    'RequestedBy',
                    'StartedAt',
                    'CompletedAt',
                    //'RunStatusId',
                    //   "HasError",
                    'ErrorMessage',
                    //   "IsFullSync",
                    'JobRunId',
                    //   "TryCount",
                    'ForceSyncDate',
                ],
                operator: 'contains',
                ignoreCase: true,
            },
            toolbar: [],
            pageSettings: {
                pageSizes: [10, 20, 50, 100],
                pageSize: 50,
                pageCount: 5,
                skip: 0,
                take: 50,
            },
            locale: '',
            runStatus: runStatus,
            modalType: ModalType,
            manageFilter: {
                startDate: new Date(),
                endDate: new Date(),
            },
            searchText: '',
            commands: [
                { type: 'View Details', buttonOption: { cssClass: 'e-flat pe-0 ps-0', iconCss: 'e-eye e-icons' } },
            ],
            moduleEnumData: ModuleEnum,
        }
    },
    mounted() {
        if (this.userStore.userInfo.isHost) {
            this.loadSubscriptions()
        }
        this.dataStateChange(
            this.initState(this.pageSettings.skip, this.pageSettings.take)
        )

        if (!this.userStore.userInfo.isHost) {
            this.loadModule()
        }
    },
    watch: {
        '$i18n.locale': {
            handler(newVal, oldVal) {
                this.gridLocalize()
            },
            immediate: true,
        },
    },
    methods: {
        initState(skip: number = 0, take: number): any {
            let state = {
                skip: skip,
                take: take,
            }
            return state
        },
        initStateDetails(): any {
            let state = {
                skip: 0,
                take: this.details.pageSettings.pageSize,
            }
            return state
        },
        commandClick(args: any) {
            if (args.commandColumn.type === 'View Details') {
                this.actionColumnClick(args.rowData);
            }
        },
        copyToClipboard(errorMessage: string) {
            navigator.clipboard.writeText(errorMessage)
        },
        actionColumnClick(rowData: SyncLog) {
            this.details.syncLogMasterId = rowData.id
            this.details.logPartitionKey = rowData.partitionKey
            this.details.logRowKey = rowData.rowKey
            this.details.companyId = rowData.companyId
            this.details.rowSubscriptionId = rowData.subscriptionId
            this.open(this.modalType.requestedModal)
            this.loadSyncLogDetails(this.initStateDetails())
        },
        dataStateChange(state: any) {
            this.pageSettings.skip = state.skip
            this.pageSettings.take = state.take

            this.gridLocalize()

            if (this.moduleId == 0) return
            this.loadSyncLog(state)
        },
        dataStateChangeDetails(state: any) {
            this.loadSyncLogDetails(state)
        },
        async loadSyncLog(state: any) {
            if (state.action) {
                delete state.action;
            }

            const { isHost, subscriptionId } = this.userStore.userInfo;
            const subParams = this.getSubscriptionParams(isHost, subscriptionId);

            const gridSyncLog: any = this.$refs.gridSyncLog;
            if (gridSyncLog) gridSyncLog.hideSpinner();

            const moduleName = this.getModuleName();

            const syncLogMasterUrl = this.getSyncLogMasterUrl();
            if (!this.subscriptionId && !(this.moduleId > 0)) {
                return;
            }

            preLoader.show();

            try {
                const moduleName = this.getModuleName();
                if (moduleName === ModuleEnum.BusinessCentral.id) {
                    await this.handleBusinessCentralSyncLog(syncLogMasterUrl, state, subParams);
                } else if (moduleName === ModuleEnum.NetVisor.id) {
                    await this.handleNetVisorSyncLog(syncLogMasterUrl, state, subParams);
                } else if (moduleName === ModuleEnum.Finance.id) {
                    await this.handleFinanceSyncLog(syncLogMasterUrl, state, subParams);
                } else {
                    await this.handleDefaultSyncLog(syncLogMasterUrl, state, subParams);
                }
            } catch (error) {
                console.error(error);
            } finally {
                preLoader.hide();
            }
        },

        getSubscriptionParams(isHost: boolean, subscriptionId: string) {
            return {
                subscriptionId: isHost ? this.subscriptionId : subscriptionId,
                moduleId: this.moduleId,
                companyId: this.companyId,
                includePending: this.includePending,
                startDate: this.formatDate(this.manageFilter.startDate),
                endDate: this.formatDate(this.manageFilter.endDate),
            };
        },

        formatDate(date: Date | null) {
            return date ? moment(date).format(SHARED.DATE_TIME_FORMAT.YYYY_MM_DD.MOMENT) : null;
        },

        getSyncLogMasterUrl() {
            return _endpointSelector.getMasterLogEndpoint(
                this.moduleList.find((x) => x.id == this.moduleId)?.name ?? ''
            );
        },

        getModuleName() {
            return this.moduleList.find((x) => x.id == this.moduleId)?.name ?? '';
        },
        isFinanceModule() {
            return this.getModuleName() === ModuleEnum.Finance.id;
        },

        async handleBusinessCentralSyncLog(url: string, state: any, params: any) {
            const response = await agent.post<ResponseBase<SyncLog>>(url, { ...state, ...params });
            if (response) {
                this.assignCompanyNames(response.data);
                this.data = {
                    result: response.data,
                    count: response.recordCount ?? 0,
                };
            }
        },

        async handleNetVisorSyncLog(url: string, state: any, params: any) {
            const response = await agent.post<NetvisorMasterSyncLogGetResponse>(url, { ...state, ...params });
            if (response) {
                response.data?.result.forEach((log) => {
                    log.companyName = this.getCompanyName(log.companyId);
                    log.requestedBy = 'NetVisorAPI';
                });
                this.data = {
                    result: response.data?.result ?? [],
                    count: response.recordCount ?? 0,
                };
            }
        },
        async handleFinanceSyncLog(url: string, state: any, params: any) {
            const response = await agent.post<FinanceMasterSyncLogGetResponse>(url, { ...state, ...params });
            if (response) {
                response.data?.result.forEach((log) => {
                    log.companyName = this.getCompanyName(log.companyId);
                    log.requestedBy = '';
                });
                this.data = {
                    result: response.data?.result ?? [],
                    count: response.data?.count ?? 0,
                };
            }
        },
        async handleDefaultSyncLog(url: string, state: any, params: any) {
            const response = await axios.post<SyncLogGetResponse>(url, { ...state, ...params }, {
                headers: { Authorization: `Bearer ${authService.getToken()}` },
            });
            if (response) {
                this.assignCompanyNames(response.data?.result?.result);
                this.data = response.data?.result;
            }
        },

        assignCompanyNames(logs: SyncLog[] | undefined) {
            logs?.forEach((log) => {
                log.companyName = this.getCompanyName(log.companyId);
            });
        },

        getCompanyName(companyId: number) {
            return this.companies.find((c) => c.id === companyId)?.name ?? 'All';
        },

        async loadSyncLogDetails(state: any) {
            if (state.action) {
                delete state.action
            }

            const gridSyncLogDetails: any = this.$refs.gridSyncLogDetails
            if (gridSyncLogDetails) gridSyncLogDetails.hideSpinner()

            const syncLogMasterId = this.details.syncLogMasterId
            const logPartitionKey = this.details.logPartitionKey
            const logRowKey = this.details.logRowKey
            const moduleId = this.moduleId
            const companyId = this.details.companyId
            const rowSubscriptionId = this.details.rowSubscriptionId


            const syncLogDetailsEndpoint =
                _endpointSelector.getMasterLogDetailsEndpoint(
                    this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name
                )

            preLoader.show()

            if (
                this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name ==
                ModuleEnum.BusinessCentral.id
            ) {
                const response = await agent.post<ResponseBase<SyncLogDetails>>(
                    syncLogDetailsEndpoint,
                    { ...state, syncLogMasterId, moduleId }
                )
                if (response) {
                    this.details.data = {
                        result: response.data,
                        count: response.recordCount ?? 0,
                    }
                }
                preLoader.hide()
            } else if (
                this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name ==
                ModuleEnum.NetVisor.id
            ) {
                const response = await agent.post<NetvisorDetailsSyncLogGetResponse>(
                    syncLogDetailsEndpoint,
                    {
                        ...state, subscriptionId: rowSubscriptionId,
                        syncLogMasterPartitionKey: logPartitionKey,
                        syncLogMasterRowKey: logRowKey, companyId: companyId
                    }
                )
                response.data?.result.forEach((log) => {
                    log.runStatusId = log.hasError ? RunStatus.Failed : RunStatus.Completed
                });
                if (response) {
                    this.details.data = {
                        result: response.data?.result ?? [],
                        count: response.data.count ?? 0,
                    }
                }

                preLoader.hide()
            } else if (
                this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name ==
                ModuleEnum.Finance.id
            ) {
                const response = await agent.post<FinanceDetailsSyncLogGetResponse>(
                    syncLogDetailsEndpoint,
                    {
                        ...state, subscriptionId: rowSubscriptionId,
                        syncLogMasterPartitionKey: logPartitionKey,
                        syncLogMasterRowKey: logRowKey, companyId: companyId
                    }
                )
                response.data?.result.forEach((log) => {
                    log.runStatusId = log.hasError ? RunStatus.Failed : RunStatus.Completed
                });
                if (response) {
                    this.details.data = {
                        result: response.data?.result ?? [],
                        count: response.recordCount ?? 0,
                    }
                }

                preLoader.hide()
            } else {
                axios
                    .post<SyncLogDetailsGetResponse>(
                        syncLogDetailsEndpoint,
                        { ...state, syncLogMasterId, logPartitionKey, logRowKey, moduleId },
                        {
                            headers: { Authorization: `Bearer ${authService.getToken()}` },
                        }
                    )
                    .then((response) => {
                        if (response) {
                            this.details.data = response.data.result
                            preLoader.hide()
                        }
                    })
                    .catch(() => {
                        preLoader.hide()
                    })
            }
        },
        onCompanyChange() {
            //this.companyId = companyId;
            this.loadSyncLog(
                this.initState(this.pageSettings.skip, this.pageSettings.take)
            )
        },
        onFilterChange() {
            //this.companyId = companyId;
            this.loadSyncLog(
                this.initState(this.pageSettings.skip, this.pageSettings.take)
            )
        },
        onSubscriptionChanged() {
            this.moduleId = 0
            this.companyId = 0
            this.data = _syncLogData
            this.loadModule()
        },
        async changeModule() {
            var moduleName = this.getModuleName();
            if (moduleName == ModuleEnum.Finance.id) {
                await this.loadLegalEntities()
            } else {
                await this.loadCompanies()
            }
            await this.loadSyncLog(
                this.initState(this.pageSettings.skip, this.pageSettings.take)
            )
        },
        gridLocalize() {
            this.locale = 'en-grid'
            if (this.$i18n.locale == 'se') {
                setTimeout(() => {
                    import(`@/assets/sv.json`).then((module) => {
                        const localText = module.default
                        this.locale = 'sv'
                        setCulture('sv')
                        L10n.load(localText)
                    })
                })
            }
        },
        open(modalType: ModalType) {
            modal.Open(modalType)
        },
        close(modalType: ModalType) {
            if (modalType == this.modalType.jobRunStatusModal) {
                this.jobRunStatus = {} as AzureJobStatusDetails
            } else if (modalType == this.modalType.requestedModal) {
                this.details.syncLogMasterId = 0
            }
            modal.Close(modalType)
        },
        async loadSubscriptions() {

            const response = await axios.get<CommonResponse<Subscription>>(
                `${masterServiceBaseURL}v1/subscription/minimal`,
                {
                    headers: { Authorization: `Bearer ${authService.getToken()}` },
                }
            )

            this.subscriptionList = response.data.result
        },
        async loadModule() {
            const { isHost, subscriptionId } = this.userStore.userInfo
            const subId = isHost ? this.subscriptionId : subscriptionId

            const response = await axios.get<CommonResponse<Module>>(
                `${masterServiceBaseURL}v1/Module/GetModules?subscriptionId=${subId}&forSyncLog=true`,
                {
                    headers: { Authorization: `Bearer ${authService.getToken()}` },
                }
            )

            this.moduleList = response.data.result
        },
        async loadCompanies() {
            const { isHost, subscriptionId } = this.userStore.userInfo
            const subId = isHost ? this.subscriptionId : subscriptionId

            preLoader.show()
            const response = await axios.get<CommonResponse<Company>>(
                `${masterServiceBaseURL}v1/Subscription/companies?subscriptionId=${subId}&moduleId=${this.moduleId}`,
                {
                    headers: { Authorization: `Bearer ${authService.getToken()}` },
                }
            )

            try {
                this.companies = response.data.result
            } catch (error) {
                console.error(error)
            }

            preLoader.hide()
        },
        async loadLegalEntities() {
            const { isHost, subscriptionId } = this.userStore.userInfo
            const subId = isHost ? this.subscriptionId : subscriptionId

            preLoader.show()


            const response = await axios.get(`${masterServiceBaseURL}v1/Subscription/legalentities?subscriptionId=${subId}`, {
                headers: { Authorization: `Bearer ${authService.getToken()}` }
            });

            try {
                this.companies = response.data.result;
            } catch (error) {
                console.error(error)
            }

            preLoader.hide()
        },
        getHoverMessage(statusId: number, hasError: boolean) {
            if (statusId == runStatus.Completed) {
                if (hasError) {
                    return this.$t('completedWithErrors')
                }
                return this.$t('completed')
            } else if (statusId == runStatus.Running) {
                return this.$t('running')
            } else if (statusId == runStatus.Pending) {
                return this.$t('pending')
            } else {
                return this.$t('failed')
            }
        },
        getRunStatusIcon(statusId: number, hasError: boolean) {
            if (statusId == runStatus.Completed) {
                if (hasError) {
                    return 'fas fa-exclamation-circle text-danger'
                }
                return 'fas fa-check-circle text-success'
            } else if (statusId == runStatus.Running) {
                return 'fas fa-spinner text-warning'
            } else if (statusId == runStatus.Pending) {
                return 'fas fa-clock text-info'
            } else {
                return 'fas fa-times-circle text-danger'
            }
        },
        getJobRunStatus(jobRunId: string) {

            const moduleName = this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name;
            const syncLogDetailsEndpoint =
                _endpointSelector.getJobRunStatusEndpoint(
                    this.moduleList.filter((x) => x.id == this.moduleId)[0]?.name
                )
            this.jobRunStatus = {} as AzureJobStatusDetails;
            preLoader.show()
            axios
                .get<any>(
                    syncLogDetailsEndpoint + `?jobRunId=${jobRunId}`,
                    {
                        headers: { Authorization: `Bearer ${authService.getToken()}` },
                    }
                )
                .then((response) => {
                    if (moduleName == ModuleEnum.NetVisor.id) {
                        if (response && response.data) {
                            this.jobRunStatus = response.data;
                            this.open(this.modalType.jobRunStatusModal)
                            preLoader.hide()
                        }
                        else {
                            toasterService.error(this.$t('noDataFound'));
                            preLoader.hide()
                        }
                    }
                    else if (response && response.data && response.data.result) {
                        this.jobRunStatus = response.data.result;
                        this.open(this.modalType.jobRunStatusModal)
                        preLoader.hide()
                    } else {
                        toasterService.error(this.$t('noDataFound'));
                        preLoader.hide()
                    }
                })
                .catch(() => {
                    preLoader.hide()
                })
        },
        onchangeDateRange(args: any) {
            if (!args.startDate || !args.endDate) return;
            this.manageFilter.startDate = args.startDate;
            this.manageFilter.endDate = args.endDate;
            this.dataStateChange(
                this.initState(this.pageSettings.skip, this.pageSettings.take)
            )
        },
        onSearch() {
            const grid = (this.$refs.gridSyncLog as any)?.ej2Instances;
            if (grid) grid.search(this.searchText);
        },
        clearSearch() {
            this.searchText = '';
            const grid = (this.$refs.gridSyncLog as any)?.ej2Instances;
            if (grid) grid.search('');
        }

    },
})
